// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".crud-fieldset-container[data-v-48ef9756]{width:-moz-min-content;width:min-content}.crud-fieldset-container .crud-fieldset-container[data-v-48ef9756]{min-width:auto}.crud-fieldset-container.crud-fieldset-container--full-width[data-v-48ef9756]{width:auto}@media screen and (max-width:700px){.crud-fieldset-container[data-v-48ef9756]{margin-left:0;margin-right:0;min-width:0;width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
